export default __webpack_public_path__ + "static/media/caloIndoorWhiteMb.7fa97126.svg";